export const getElementsBetween = (leaf: HTMLElement, root: HTMLElement) => {
  if (!root.contains(leaf)) {
    throw new Error('The leaf element must be a decendant of the root!');
  }

  if (leaf === root) {
    return [];
  }

  const betweens = [];
  let current = leaf;
  while (true) {
    // given that the root contains leaf
    // and that search so far from leaf up its ancestry tree never found root yet
    // this should always be defined
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const leafParent = current.parentElement!;
    if (leafParent === root) {
      return betweens;
    }
    betweens.push(leafParent);
    current = leafParent;
  }
};

export const FOCUSABLE_TAGS = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT'];
export const INTERACTABLE_TAGS = FOCUSABLE_TAGS.concat(['LABEL']);

const isInteractableExceptions = (element: HTMLElement) => {
  if (element.getAttribute('role') === 'menu') {
    // somehow using arrow keys on dropdown menus sends a click event from the menu
    // it doesn't happen in single widget mode, so probably old bootstrap/jquery doing crappy stuff
    return true;
  }
  return false;
};

export const isInteractable = (element: HTMLElement) => {
  return (
    INTERACTABLE_TAGS.includes(element.tagName) ||
    element.getAttribute('role')?.includes('button') ||
    isInteractableExceptions(element)
  );
};

export const hasInteractableBetween = (leaf: HTMLElement, root: HTMLElement) => {
  return !!findFirstInteractableBetween(leaf, root);
};

export const findFirstInteractableBetween = (leaf: HTMLElement, root: HTMLElement) => {
  return getElementsBetween(leaf, root).find(isInteractable);
};

export const makeElementClickable = (ele: HTMLElement, onClick: (e: MouseEvent | KeyboardEvent) => void) => {
  ele.setAttribute('tabIndex', '0');
  ele.classList.add('cursor-pointer');

  const keyListener = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === 'Space') {
      onClick(e);
    }
  };
  ele.addEventListener('click', onClick);
  ele.addEventListener('keypress', keyListener);

  return () => {
    ele.removeEventListener('click', onClick);
    ele.removeEventListener('keypress', keyListener);
  };
};
